var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#acacac;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1047 -489)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 22,
    height: 25,
    transform: "translate(1047 489)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1015.64 489)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M245.746,251.487c-.13-.432-.259-.971-.367-1.4h-.022c-.108.431-.215.982-.334,1.4l-.431,1.542H246.2Z",
    transform: "translate(-203.575 -238.76)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M51.958,8.882h-.6V6a.418.418,0,0,0-.005-.054.478.478,0,0,0-.116-.315L46.454.167l0,0a.479.479,0,0,0-.1-.081L46.321.063a.508.508,0,0,0-.1-.04L46.2.014A.484.484,0,0,0,46.087,0H34.322a.975.975,0,0,0-.974.974V8.881h-.6a1.392,1.392,0,0,0-1.392,1.392V17.51A1.392,1.392,0,0,0,32.752,18.9h.6v4.954a.975.975,0,0,0,.974.974H50.388a.975.975,0,0,0,.974-.974V18.9h.6A1.392,1.392,0,0,0,53.35,17.51V10.273A1.392,1.392,0,0,0,51.958,8.882ZM34.322.974H45.6V5.956a.487.487,0,0,0,.487.487h4.3V8.882H34.322ZM45.191,17.366h-1.77L42.861,15.5H40.779l-.518,1.866h-1.7l2.222-7.27h2.157ZM34.22,14.508v2.858H32.591V10.193a14.4,14.4,0,0,1,2.19-.151,3.71,3.71,0,0,1,2.352.572,1.847,1.847,0,0,1,.669,1.521,1.929,1.929,0,0,1-1.284,1.791v.032a1.832,1.832,0,0,1,.971,1.359c.227.82.453,1.769.593,2.049H36.4a9.038,9.038,0,0,1-.507-1.694c-.194-.906-.507-1.154-1.176-1.165h-.5Zm16.168,9.085H34.322V18.9H50.388v4.691Zm-.417-6.227a9.068,9.068,0,0,1-.507-1.694c-.194-.906-.507-1.154-1.175-1.165h-.5v2.858H46.163V10.193a14.4,14.4,0,0,1,2.189-.151,3.71,3.71,0,0,1,2.352.572,1.846,1.846,0,0,1,.669,1.521,1.93,1.93,0,0,1-1.284,1.791v.032a1.831,1.831,0,0,1,.971,1.359c.227.82.453,1.769.594,2.049H49.971Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M96.458,249.66c0-.669-.453-1-1.208-1.014a4.1,4.1,0,0,0-.745.054v2.006h.647C95.973,250.707,96.458,250.3,96.458,249.66Z",
    transform: "translate(-60.285 -237.386)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M394.939,248.651a4.1,4.1,0,0,0-.745.054v2.006h.647c.819,0,1.305-.41,1.305-1.046C396.147,249,395.694,248.662,394.939,248.651Z",
    transform: "translate(-346.403 -237.391)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRar);
export default __webpack_public_path__ + "static/media/rar.924264c8cd7e8491330469af1d851581.svg";
export { ForwardRef as ReactComponent };